export default __webpack_public_path__ + "static/media/glass.238938de.svg";